
<template>
  <v-dialog v-model="displayDialog"
            hide-overlay
            :max-width="isPhoneBool ? '90vw' : '40vw'">
    <v-card color="primary"
            class="white--text pa-4">
      <v-btn @click="displayDialog = false"
             absolute
             right
             icon>
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <h2 v-text="$t('firsttimemessage_title', {ukey: userInfo.Name})"
          class="text-center" />
      <v-divider class="mt-3 mb-2 white" />
      <div v-html="$t('firsttimemessage_body')"></div>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  name: "FirstTimeDialog",
  components: {},

  data() {
    return {
      displayDialog: false,
      version: 1,
    };
  },

  created() {
    //localStorage.removeItem("FirstTimeV1")
    //var stored = JSON.parse(localStorage.getItem("FirstTimeV" + this.version || false));
    //this.displayDialog = stored ? false : true; //if not stored show dialog
  },

  mounted() {},

  methods: {},

  computed: {},

  watch: {
    displayDialog: function (newVal) {
      if (!newVal) {
        localStorage.setItem("FirstTimeV" + this.version, JSON.stringify(true));
      }
    },
  },
};
</script>